import { useTranslation } from 'react-i18next';
import { Button } from '../../ui';

/** The service is down or unreachable (P12a): said plainly, with a retry, instead of an empty or wrong page. */
export function ServiceUnavailable({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation();
  return (
    <div role="alert" className="flex flex-wrap items-center gap-3 rounded-md border border-border bg-surface px-4 py-3 font-sans text-sm text-fg">
      <p className="flex-1">{t('dashboard.unavailable')}</p>
      <Button variant="secondary" size="sm" onClick={onRetry}>
        {t('dashboard.retry')}
      </Button>
    </div>
  );
}
